export default __webpack_public_path__ + "static/media/photo-06.e0356b9c.jpeg";